import { useEffect } from "react";
import { motion } from "framer-motion";

const LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_design-breakthrough/artifacts/tyi8grfo_Original%20on%20transparent.webp";

export const Intro = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      exit={{ y: "-100%" }}
      transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col items-center justify-center"
      data-testid="intro-overlay"
    >
      <motion.img
        src={LOGO}
        alt="WVE Studios"
        initial={{ opacity: 0, scale: 0.82, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="w-[240px] sm:w-[320px] h-auto"
      />
      <motion.p
        initial={{ opacity: 0, letterSpacing: "0.1em" }}
        animate={{ opacity: 1, letterSpacing: "0.4em" }}
        transition={{ delay: 0.9, duration: 0.8 }}
        className="text-white/60 uppercase text-[10px] sm:text-sm mt-8 font-medium text-center px-4"
      >
        Video · Photography · Events
      </motion.p>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 0.4, duration: 1.8, ease: "easeInOut" }}
        className="absolute bottom-0 left-0 right-0 h-1.5 bg-[#E80042] origin-left"
      />
    </motion.div>
  );
};
